import { useState } from "react";

export default function useToggle(initialState) {
  const [isOpen, setOpen] = useState(initialState ?? false);

  const toggle = () => {
    setOpen(prev => !prev);
  };

  return [isOpen, setOpen, toggle];
}
